import generic from './generic'

const getDefaultState = () => {
  return {
    all: null,
    errored: false,
    loading: false,
    fetchedAt: null,
    ageLimit: 30,
  }
}

const state = getDefaultState()

const mutations = {
  ...generic.mutations,
  'RESET': function (state) {
    Object.assign(state, getDefaultState())
  },
}

const actions = {
  ...generic.actions,
  getAll (context) {
    return generic.getAll(context, {type: 'stats'})
  },
  backgroundRefresh (context) {
    return generic.getAll(context, {type: 'stats', hideLoading: true})
  },
}

const getters = {
  ...generic.getters,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
